/* eslint-disable func-names */

import * as Yup from "yup";
import i18n from "../i18n";
import { formatNumber } from "./numberFormat";
const { t } = i18n;

export const REGEX = {
  PHONE:
    /(\+84|\84|0)+(3[2-9]|5[6|8|9]|9\d(?!5)|8[1-9]|7[0|6-9])+([0-9]{7})\b/i,
  NUMBER: /^[0-9]+$/,
  ALIAS: /^[a-z0-9_-]{1,100}$/i,
  CODE: /^[a-z0-9A-ZđĐ]+$/,
  USERNAME: /^(\d|\w)+$/,
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  TIMOR_PHONE: /^(75|76)\d{6,9}$/,
  VIETNAMESE_AND_NUMBER:
    /^[0-9a-zA-ZàáảãạăằắẳẵặâầấẩẫậđèéẻẽẹêềếểễệìíỉĩịòóỏõọôồốổỗộơờớởỡợùúủũụưừứửữựỳýỷỹỵÀÁẢÃẠĂẰẮẲẴẶÂẦẤẨẪẬĐÈÉẺẼẸÊỀẾỂỄỆÌÍỈĨỊÒÓỎÕỌÔỒỐỔỖỘƠỜỚỞỠỢÙÚỦŨỤƯỪỨỬỮỰỲÝỶỸỴ[\]{}\\|\s]+$/,
};

Yup.addMethod(
  Yup.string,
  "phone",
  function (errorMessage = t("validation.phone")) {
    return this.matches(REGEX.PHONE, {
      message: errorMessage,
      excludeEmptyString: true,
    });
  }
);

Yup.addMethod(
  Yup.string,
  "number",
  function (errorMessage = t("validation.not_number")) {
    return this.matches(REGEX.NUMBER, {
      message: errorMessage,
      excludeEmptyString: true,
    });
  }
);
Yup.addMethod(
  Yup.string,
  "alias",
  function (errorMessage = t("validation.alias")) {
    return this.matches(REGEX.ALIAS, {
      message: errorMessage,
      excludeEmptyString: true,
    });
  }
);

Yup.addMethod(
  Yup.string,
  "code",
  function (errorMessage = t("validation.code")) {
    return this.matches(REGEX.CODE, {
      message: errorMessage,
      excludeEmptyString: true,
    });
  }
);

Yup.addMethod(Yup.string, "minLength", function (limit, errorMessage) {
  return this.min(
    limit,
    errorMessage || t("validation.min", { number: limit })
  );
});

Yup.addMethod(Yup.string, "maxLength", function (limit, errorMessage) {
  return this.max(
    limit,
    errorMessage || t("validation.max", { number: limit })
  );
});

Yup.addMethod(
  Yup.string,
  "password",
  function (errorMessage = t("validation.password")) {
    return this.test("PASSWORD", errorMessage, (value) => {
      return (
        /^[A-Z]/.test(value[0]) &&
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,100}$/.test(
          value
        )
      );
    });
  }
);

Yup.addMethod(
  Yup.string,
  "confirm_password",
  function (fieldPath, errorMessage = t("validation.confirm_password")) {
    return this.test("CONFIRM_PASSWORD", errorMessage, function (value) {
      const fieldValue = this?.parent?.[fieldPath];

      return fieldValue === value;
    });
  }
);

export const changeYupLocale = () => {
  Yup.setLocale({
    mixed: {
      required: t("validation.required"),
      notType: t("validation.required"),
    },
    string: {
      required: t("validation.required"),
      email: t("validation.email"),
      phone: t("validation.phone"),
      max: ({ max }) => t("validation.max", { number: max }),
      min: ({ min }) => t("validation.min", { number: min }),
      url: t("validation.url"),
    },
    date: {
      min: t("validation.invalid"),
      max: t("validation.invalid"),
      required: t("validation.required"),
    },
    array: {
      min: t("validation.required"),
    },
    number: {
      required: t("validation.required"),
      min: ({ min }) =>
        t("validation.number_min", { min: formatNumber(min, ".") }),
      max: ({ max }) =>
        t("validation.number_max", { max: formatNumber(max, ".") }),
      moreThan: ({ more }) => t("validation.more_than", { more }),
      integer: () => t("validation.integer"),
    },
  });
};
export default Yup;
